<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.zencustomers" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a routerLink="../..">ZEN Master Sites</a>
			</li>
			<li class="breadcrumb-item"><a routerLink="..">Reports</a></li>
			<li class="breadcrumb-item active" aria-current="page">
				Channels
			</li>

		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<form [formGroup]="theForm" class="cp-general-width-limit">
		<div class="form-group">
			<div class="input-group">
				<input type="text" id="searchTerm" formControlName="searchTerm" class="form-control" placeholder="Search Term" minlength="2"
					size="10" (keyup.enter)="onFormChange()" />
				<button class="btn btn-primary" type="button" [disabled]="!theForm.valid || loading" (click)="onFormChange()">
					<fa-icon [icon]="['fas', 'search']"></fa-icon>
					<span class="cp-action-button-text">Search</span>
				</button>
			</div>
		</div>
	</form>

	<div *ngIf="loading" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<div *ngIf="!loading && searchTerm === ''" class="cp-warning-message ">
		You must supply a search term.
	</div>

	<div *ngIf="!loading && searchTerm !== '' && itemsToShow.length === 0" class="cp-warning-message ">
		No search results.
	</div>

	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>

		</thead>
		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow" [routerLink]="getSiteRoute(item)" class="cp-pointer">
				<td>
					<a [routerLink]="getSiteRoute(item)">{{ item['__prefix'] }}</a>
				</td>
				<td>{{ item.name }}</td>
				<td>{{ item.channel_type }}</td>
			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>